import {WriteButton} from '../common/buttons/WriteActions';
import {Box, Stack, Typography} from '@mui/material';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import EditIcon from '@mui/icons-material/Edit';
import {ItemDto} from '../../models/Items/IItem';
import {UNIT_OF_WEIGHT} from '@mybake/ui/common/dictionary';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';
import {useCurrency} from '../../hooks/useCurrency';

type Props = { item: ItemDto; onAddPurchase: (item: ItemDto) => void; onEdit: (item: ItemDto) => void; };
const amount = (item: ItemDto) => item.unitOfWeight === UNIT_OF_WEIGHT.G ? `${item.totalWeight} kg` : `${item.count} ${item.unitOfWeight}`;

export const IngredientDetailCard = ({item, onAddPurchase, onEdit}: Props) => {
    const {t} = useAppTranslation();
    const {formatCurrency} = useCurrency();

    return <Box>
        <Stack direction="row" alignItems="center" flexWrap="wrap" gap={{xs: 1, sm: 2}}>
            <Typography variant="body2"><Box component="span" color="text.secondary">{t('items:current_stock')}: </Box><Box component="span" fontWeight={700}>{amount(item)}</Box></Typography>
            {item.lastPrice !== undefined && <Typography variant="body2"><Box component="span" color="text.secondary">{t(item.unitOfWeight === UNIT_OF_WEIGHT.PCS ? 'items:current_package_price' : 'items:last_price')}: </Box><Box component="span" fontWeight={700}>{formatCurrency(item.lastPrice)}</Box></Typography>}
            {!!item.pricePerUnit && <Typography variant="body2"><Box component="span" color="text.secondary">{t('items:unit_price')}: </Box><Box component="span" fontWeight={700}>{formatCurrency(item.pricePerUnit)}</Box></Typography>}
        </Stack>
        <Stack direction={{xs: 'column', sm: 'row'}} justifyContent="flex-end" spacing={1} sx={{mt: 2}}><WriteButton onClick={() => onEdit(item)} startIcon={<EditIcon/>}>{t('items:edit_ingredient')}</WriteButton><WriteButton variant="contained" onClick={() => onAddPurchase(item)} startIcon={<AddShoppingCartIcon/>}>{t('items:add_purchase')}</WriteButton></Stack>
    </Box>;
};
